<script>
import ListResponseActivityAnswersComponent from '../../features/lists/ListResponseActivityAnswersComponent';
import ModalResponseActivityAnswerView from '../modals/ModalResponseActivityAnswerView';
import ModalImportView from '../../../shared/views/ModalImportView';


export default {
  name: 'ListResponseActivityAnswersView',
  components: {
    'modal-response-activity-answer-view': ModalResponseActivityAnswerView,
    'modal-import': ModalImportView,
  },
  extends: ListResponseActivityAnswersComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row
      :gutter="20"
      class="section-ctrl course-categories"
    >
      <el-col
        :xs="24"
        :sm="9"
        :md="11"
        :lg="6"
        :xl="4"
        class="header-right"
      >
        <el-button-group class="btn-grp-drp">
          <!-- <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            @click="onCreate"
            :disabled="!onCanCreate(modulePermissions)"
            >Crear Curso</el-button
          > -->
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> M&aacute;s Opciones
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Cursos
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              <!--<el-dropdown-item>
                <el-button size="small" class="btn-white">
                  <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Exportar PDF
                </el-button>
              </el-dropdown-item>-->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> Filtrar Por <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.courseFilter"
                    size="small"
                    filterable
                    remote
                    clearable
                    placeholder="Curso..."
                    :remote-method="onSearchCourse"
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.courseFilter.id, 'CourseId')"
                    @focus="onFocusCourse"
                  >
                    <el-option
                      v-for="item in courses"
                      :key="item.id"
                      :label="item.title"
                      :value="item"
                    />
                  </el-select>
                </el-dropdown-item>
              <!--
              <el-dropdown-item>
                <el-select size="small" v-model="filterOptions.studentFilter" filterable remote clearable placeholder="Estudiante..."
                :remote-method="onSearchStudent" @change="onAllFilterChange(filterOptions.studentFilter.id, 'StudentId')" @focus="onFocusStudent"
                value-key="id">
                  <el-option v-for="item in students" :key="item.id" :label="item.firstName +' '+ item.lastName" :value="item"></el-option>
                </el-select>
              </el-dropdown-item>
              -->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
      </el-col>
      <el-col
        :xs="24"
        :sm="5"
        :md="5"
        :lg="6"
        :xl="5"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="Buscar por Tema."
          placement="top"
        >
          <el-input
            v-model="filterOptions.courseSubjectFilter"
            size="small"
            placeholder="Buscar Tema..."
            icon="search"
            suffix-icon="el-icon-search"
            @keyup.enter="onAllFilterChange(filterOptions.courseSubjectFilter, 'CourseSubjectTitle')"
          />
        </el-tooltip>
      </el-col>
      <el-col
        :xs="24"
        :sm="5"
        :md="5"
        :lg="6"
        :xl="5"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="Buscar por Actividad."
          placement="top"
        >
          <el-input
            v-model="filterOptions.courseSubjectActivityFilter"
            size="small"
            placeholder="Buscar Actividad..."
            icon="search"
            suffix-icon="el-icon-search"
            @keyup.enter="onAllFilterChange(filterOptions.courseSubjectActivityFilter, 'CourseSubjectActivityTitle')"
          />
        </el-tooltip>
      </el-col>
    </el-row>
    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label=""
        width="50"
      >
        <template #default="scope">
          <div>
            <el-avatar :src="mapProfileImage(scope.row.userProfile)" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="ESTUDIANTE"
        min-width="300"
      >
        <template #default="scope">
          <div>
            {{ scope.row.userProfile.firstName }} {{ scope.row.userProfile.lastName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="ACTIVIDAD"
        min-width="320"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.courseSubjectActivity.title }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="TEMA"
        align="center"
        min-width="250"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.courseSubjectActivity.courseSubject.title }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="CURSO"
        align="center"
        min-width="250"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.courseSubjectActivity.courseSubject.courseSection.course.title }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="CREACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.createdAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="ACTUALIZACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            v-if="onCheckUpdatedAt(scope.row.updatedAt)"
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.updatedAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="OPCIONES"
        :width="160"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-response-activity-answer-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>

